// extracted by mini-css-extract-plugin
module.exports = {"layoutBG__wrapper":"style-module--layoutBG__wrapper--3G8y5"};